import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { Box, makeStyles, Typography } from "@material-ui/core";

import { COLORS } from "../../../../../theme/colors";
import { ShaDowBox } from "../../../../../components/boxes";
import { getData, nFormatter } from "../../../../../services";
import { NoDataCard, TenancyChart } from "../../../../../components/parts";
import { vacancyKeys } from "../../../constants";

const bars = [
  {
    dataKey: "building",
    fill: COLORS.blue,
    barSize: 18,
    unit: "unitSystem",
  },
  {
    dataKey: "portfolio",
    fill: COLORS.spanishGray,
    barSize: 18,
    unit: "unitSystem",
  },
  {
    dataKey: "industry",
    fill: COLORS.darks[0][100],
    barSize: 18,
    unit: "unitSystem",
  },
];

const percentUnitBars = bars.map((bar) => ({ ...bar, unit: "%" }));

const defaultChartData = [
  {
    key: "unit_areas",
    title: "",
    suffix: "",
    suffixColor: COLORS.blue,
    chartData: [],
    name: "Units Area",
    bars: bars,
  },
  {
    key: "public_areas",
    title: "",
    suffix: "",
    suffixColor: COLORS.blue,
    chartData: [],
    name: "Public Areas",
    bars: bars,
  },
  {
    key: "public_leased",
    title: "",
    chartData: [],
    suffixColor: COLORS.blue,
    name: "Public Areas Vs. Leased Units",
    bars: percentUnitBars,
  },
  {
    key: "physical_vacancy",
    title: "",
    suffix: "",
    suffixColor: COLORS.blue,
    chartData: [],
    name: "Current Physical Vacancy",
    bars: percentUnitBars,
  },
  {
    key: "economic_vacancy",
    title: "",
    suffix: "",
    suffixColor: COLORS.blue,
    chartData: [],
    name: "Current Economic Vacancy",
    bars: percentUnitBars,
  },
];

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(3.5),
  },
}));

export const TenancyDataGraph = ({ buildingId, complexId }) => {
  const classes = useStyles();
  const [chartData, setChartData] = useState([]);
  const { user } = useSelector((state) => state.auth);
  const { cluster, segments, selectedCountries } = useSelector((state) => state.selectCSC);

  const url = buildingId
    ? `/praas/v2/buildings/${buildingId}/properties/charts/`
    : `/praas/v2/complexes/${complexId}/properties/charts/`;

  useEffect(() => {
    getData(url, (data) => {
      defaultChartData.forEach((item) => {
        const { percent, ...obj } = data[item.key];
        const onlyZeroValues = obj.building === (vacancyKeys.includes(item.key) ? null : 0);
        const titleValue = "square" in obj ? obj.square : obj.building;
        item.suffix =
          item.key === "public_leased" ||
          (vacancyKeys.includes(item.key) && percent && onlyZeroValues) ||
          !titleValue ? (
            <Typography component="span" style={{ color: COLORS.blue }}>
              {percent} %
            </Typography>
          ) : percent ? (
            `(${percent} %)`
          ) : null;
        item.chartData = [obj];
        item.title =
          item.key === "public_leased" || !titleValue
            ? ""
            : `${nFormatter(titleValue)} ${user?.unit_system}`;
        item.checkValue = percent;
        item.onlyZeroValues = onlyZeroValues;
      });
      setChartData(defaultChartData);
    });

    return () => setChartData([]);
  }, [buildingId, complexId, cluster, segments, selectedCountries]);

  return (
    <Box className={classes.root}>
      {chartData.length ? (
        <ShaDowBox style={{ padding: "32px 0" }}>
          <TenancyChart chartData={chartData} checkTitleKeys={vacancyKeys} />
        </ShaDowBox>
      ) : (
        <NoDataCard
          rootStyle={{ minHeight: 316 }}
          footerNames={["In this building", "Avg. portfolio", "Avg. Industry"]}
        />
      )}
    </Box>
  );
};
